import { IconName } from '@fortawesome/fontawesome-svg-core';
import { Icon } from '@y42/core/icon';
import { ColumnState, GridApi } from 'ag-grid-community';
import { v4 as uuid } from 'uuid';

export class QuickFilterModel {
  constructor(data: Partial<QuickFilterModel>) {
    this.id = data.id || uuid();
    this.name = data.name || '';
    this.filterModel = data.filterModel || {};
    this.default = data.default || false;
    this.editable = data.editable || false;
    this.background_color = data.background_color || '';
    this.icon = data.icon || ('' as IconName);
    this.is_font_awesome = data.is_font_awesome || false;
    this.columnStates = data.columnStates;
    this.icon_width = data?.icon_width ? data?.icon_width : 13;
  }

  id: string;
  name: string;
  filterModel: ReturnType<GridApi['getFilterModel']>;
  default: boolean;
  editable: boolean;
  background_color: string;
  icon: Icon;
  is_font_awesome: boolean;
  columnStates?: ColumnState[];
  icon_width?: number;
}
